import React from "react";
import CreateTicket from "./CreateTicket";
import Hero from "./Hero";

function SupportPage() {
  return (
    <>
      <Hero />
      <CreateTicket />
    </>
  );
}

export default SupportPage;
